import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "control" }
const _hoisted_2 = { class: "button is-static" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("option", { value: "single" }, "Single", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("option", { value: "daily" }, "Daily", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("option", { value: "monthly" }, "Monthly", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: "yearly" }, "Yearly", -1)
const _hoisted_7 = { class: "control" }


import moment from "moment";
import { useForm, useField } from "vee-validate";
import { UseNumberHelper } from "../../../Helper/Functional/UseNumberHelper";
import { UseValidateHelper } from "../../../Helper/Functional/UseValidateHelper";
import { computed, ref, watch, watchEffect } from "vue";
import {
  IFixedCosts,
  IFixedRequest,
} from "../../../Pages/Admin/FixedCosts/Typings/FixedCostsTypes";
import { isEmpty, assign } from "lodash";
import swal from "sweetalert2";

const __default__ = {
  name: "AddFixedCostFields",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    cost: null,
    startDate: null,
    endDate: null,
    fixedCosts: null,
    frequency: null,
    originalFrequency: null,
    taxonomyOne: null,
    taxonomyTwo: null,
    taxonomyThree: null,
    taxonomyFour: null,
    request: null,
    saving: { type: Boolean },
    isNew: { type: Boolean }
  },
  emits: ["update:cost", "update:startDate", "update:endDate", "update:frequency", "update:originalFrequency", "update:taxonomyOne", "update:taxonomyTwo", "update:taxonomyThree", "update:taxonomyFour", "update:request", "save"],
  setup(__props: any, { emit }: { emit: ({
  (e: "update:cost", val: string): void;
  (e: "update:startDate", val: string): void;
  (e: "update:endDate", val: string): void;
  (e: "update:frequency", val: string): void;
  (e: "update:originalFrequency", val: string): void;
  (e: "update:taxonomyOne", val: string): void;
  (e: "update:taxonomyTwo", val: string): void;
  (e: "update:taxonomyThree", val: string): void;
  (e: "update:taxonomyFour", val: string): void;
  (e: "update:request", val: IFixedRequest);
  (e: "save"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  cost?: string | number;
  startDate: string;
  endDate: string;
  fixedCosts: IFixedCosts[];
  frequency: string;
  originalFrequency: string;
  taxonomyOne?: string;
  taxonomyTwo?: string;
  taxonomyThree?: string;
  taxonomyFour?: string;
  request: IFixedRequest;
  saving: boolean;
  isNew: boolean;
}

const { displayCurrencySymbol } = UseNumberHelper();



//Component Data
const costError = ref("");

//Computed

const requestCompute = computed(
  (): IFixedRequest => {
    let rtn = {
      taxonomy_1: props.taxonomyOne,
      cost: props.cost,
      start_date: props.startDate,
      frequency: props.originalFrequency,
    };

    if (!isEmpty(props.taxonomyTwo)) {
      assign(rtn, { taxonomy_2: props.taxonomyTwo });
    }

    if (!isEmpty(props.taxonomyThree)) {
      assign(rtn, { taxonomy_3: props.taxonomyThree });
    }

    if (!isEmpty(props.taxonomyFour)) {
      assign(rtn, { taxonomy_4: props.taxonomyFour });
    }

    if (props.originalFrequency !== "single") {
      assign(rtn, { end_date: props.endDate });
    }

    return rtn;
  }
);

const costCompute = computed({
  get(): string {
    return props.cost as string;
  },
  set(val: string) {
    emit("update:cost", val);
  },
});
const startDateCompute = computed({
  get() {
    return new Date(props.startDate);
  },
  set(val: Date | string) {
    emit("update:startDate", moment(val).format("YYYY-MM-DD"));
  },
});
const endDateCompute = computed({
  get() {
    return new Date(props.endDate);
  },
  set(val: Date) {
    emit("update:endDate", moment(val).format("YYYY-MM-DD"));
  },
});

const originalFrequencyCompute = computed({
  get(): string {
    return props.originalFrequency;
  },
  set(val: string) {
    emit("update:originalFrequency", val);
  },
});
const taxonomyOneCompute = computed({
  get(): string {
    return props.taxonomyOne as string;
  },
  set(val: string) {
    emit("update:taxonomyOne", val);
  },
});
const taxonomyTwoCompute = computed({
  get(): string {
    return props.taxonomyTwo as string;
  },
  set(val: string) {
    return emit("update:taxonomyTwo", val);
  },
});
const taxonomyThreeCompute = computed({
  get(): string {
    return props.taxonomyThree as string;
  },
  set(val: string) {
    return emit("update:taxonomyThree", val);
  },
});
const taxonomyFourCompute = computed({
  get(): string {
    return props.taxonomyFour as string;
  },
  set(val: string) {
    return emit("update:taxonomyFour", val);
  },
});

//Form and Field stuff;
const { isRequired } = UseValidateHelper();
const { handleSubmit } = useForm();

const save = handleSubmit(() => {
  Promise.all([taxonomyOneValidate, costValidate])
    .then(async (res) => {
      const result = await Promise.all(res.map((f) => f()));
      if (result.every((v) => v.valid)) {
        emit("save");
      } else {
        swal.fire({
          toast: true,
          type: "error",
          position: "top-end",
          timer: 3000,
          text: "The spend configuration is not valid! Please check the fields.",
        });
      }
    })
    .catch(() => {
      swal.fire({
        toast: true,
        type: "error",
        position: "top-end",
        timer: 3000,
        text: "The spend configuration is not valid! Please check the fields.",
      });
    });
});

const {
  errorMessage,
  value: taxonomyOne,
  handleChange,
  validate: taxonomyOneValidate,
} = useField("taxonomyOne", isRequired("The taxonomy one field is required."));

const {
  errors: costErrorMessage,
  value: cost,
  validate: costValidate,
} = useField("costs", [isRequired("The spend field is required")]);

watchEffect(() => {
  taxonomyOneCompute.value = taxonomyOne.value as string;
  costCompute.value = cost.value as string;
});

watch(requestCompute, (newVal: IFixedRequest) => {
  emit("update:request", newVal);
});

return (_ctx: any,_cache: any) => {
  const _component_o_input = _resolveComponent("o-input")!
  const _component_o_field = _resolveComponent("o-field")!
  const _component_o_select = _resolveComponent("o-select")!
  const _component_o_datepicker = _resolveComponent("o-datepicker")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_component_o_field, {
      horizontal: "",
      label: "Taxonomy 1",
      message: _unref(errorMessage),
      variant: _unref(errorMessage) ? 'danger' : ''
    }, {
      default: _withCtx(() => [
        _createVNode(_component_o_input, {
          "data-vv-as": "taxonomy one",
          modelValue: _unref(taxonomyOne),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(taxonomyOne) ? (taxonomyOne).value = $event : null)),
          name: "taxonomyOne",
          expanded: "",
          onChange: _unref(handleChange)
        }, null, 8, ["modelValue", "onChange"])
      ]),
      _: 1
    }, 8, ["message", "variant"]),
    _createVNode(_component_o_field, {
      horizontal: "",
      label: "Taxonomy 2"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_o_input, {
          modelValue: _unref(taxonomyTwoCompute),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(taxonomyTwoCompute) ? (taxonomyTwoCompute).value = $event : null)),
          name: "taxonomyTwo",
          expanded: ""
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_o_field, {
      horizontal: "",
      label: "Taxonomy 3"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_o_input, {
          modelValue: _unref(taxonomyThreeCompute),
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(taxonomyThreeCompute) ? (taxonomyThreeCompute).value = $event : null)),
          name: "taxonomyThree",
          expanded: ""
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_o_field, {
      horizontal: "",
      label: "Taxonomy 4"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_o_input, {
          modelValue: _unref(taxonomyFourCompute),
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(taxonomyFourCompute) ? (taxonomyFourCompute).value = $event : null)),
          name: "taxonomyFour",
          expanded: ""
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_o_field, {
      horizontal: "",
      label: "Spend",
      message: _unref(costErrorMessage)[0],
      variant: _unref(costErrorMessage) || costError.value.length ? 'danger' : ''
    }, {
      default: _withCtx(() => [
        _createVNode(_component_o_field, {
          message: _unref(costErrorMessage)[1 || costError.value],
          variant: _unref(costErrorMessage)[1] || costError.value.length ? 'danger' : ''
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_1, [
              _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(displayCurrencySymbol)), 1)
            ]),
            _createVNode(_component_o_input, {
              "data-vv-as": "spend",
              modelValue: _unref(cost),
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(cost) ? (cost).value = $event : null)),
              expanded: "",
              name: "cost",
              type: "number",
              step: "0.01"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["message", "variant"])
      ]),
      _: 1
    }, 8, ["message", "variant"]),
    _createVNode(_component_o_field, {
      horizontal: "",
      label: "Frequency"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_o_select, {
          expanded: "",
          "data-vv-as": "frequency",
          name: "frequency",
          modelValue: _unref(originalFrequencyCompute),
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(originalFrequencyCompute) ? (originalFrequencyCompute).value = $event : null))
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _hoisted_4,
            _hoisted_5,
            _hoisted_6
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_o_field, {
      horizontal: "",
      label: "Duration"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_o_datepicker, {
          "data-vv-as": "start date",
          ref: "start date",
          class: "is-marginless",
          name: "startDate",
          expanded: "",
          modelValue: _unref(startDateCompute),
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(startDateCompute) ? (startDateCompute).value = $event : null))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_o_datepicker, {
          "data-vv-as": "end date",
          ref: "end date",
          disabled: __props.originalFrequency == 'single',
          class: "is-marginless",
          name: "endDate",
          expanded: "",
          modelValue: _unref(endDateCompute),
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(endDateCompute) ? (endDateCompute).value = $event : null))
        }, null, 8, ["disabled", "modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_o_field, { horizontal: "" }, {
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_7, [
          _createElementVNode("button", {
            class: _normalizeClass(['button', 'is-primary', { 'is-loading': __props.saving }]),
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_unref(save) && _unref(save)(...args)))
          }, _toDisplayString(__props.isNew ? "Create" : "Save") + " Spend ", 3)
        ])
      ]),
      _: 1
    })
  ]))
}
}

})